// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-clip__container {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 32px 39px;
}

.baloa-play-clip__left-section {
    border-radius: 8px;
    background: var(--white-color);
    padding: 24px;
    width: calc(50% - 12px);
}

.baloa-play-clip__section {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: calc(50% - 12px);
}

.baloa-play-clip__right-section {
    border-radius: 8px;
    background: var(--white-color);
    padding: 16px;
}

.baloa-play-clip__actions {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    margin-top: 10px;
}

.baloa-play-clip__actions-image {
    border-radius: 8px;
    width: 175px;
    height: 182px;
    position: relative;
}

.baloa-play-clip__actions img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.baloa-play-clip__actions-items {
    padding: 12px 0;
}

.baloa-play-clip__left-section .baloa-normal-medium {
    font-size: 18px;
    color: var(--primary-very-dark-color);
    line-height: unset;
}

.baloa-play-clip__actions-items__action {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    margin-bottom: 20px;
    cursor: pointer;
}

.baloa-play-clip__actions-items__action .hubicon-play_circle1,
.baloa-play-clip__actions-items__action .hubicon-download,
.baloa-play-clip__actions-items__action .hubicon-edit1 {
    font-size: 20px;
    color: var(--primary-very-dark-color);
}

.baloa-play-clip__actions-items__action .baloa-names {
    color: var(--primary-very-dark-color);
    line-height: unset;
}

.baloa-play-clip__actions-items__action.disabled {
    cursor: not-allowed;
    pointer-events: none;
}

.baloa-play-clip__actions-items__action.disabled .hubicon-play_circle1,
.baloa-play-clip__actions-items__action.disabled .hubicon-download,
.baloa-play-clip__actions-items__action.disabled .baloa-names {
    opacity: 0.4;
}

.baloa-play-clip__options {
    margin-top: 10px;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
}

.baloa-play-clip__options__option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 14px;
    cursor: pointer;
}

.baloa-play-clip__options__option:not(:last-child) {
    border-bottom: 1px solid var(--new-gray-background-color);
}

.baloa-play-clip__options__option .baloa-names {
    color: var(--primary-very-dark-color);
    line-height: unset;
}

.baloa-play-clip__options__option .hubicon-video_library1::before {
    font-size: 20px;
    color: #0D6EFD;
}

.baloa-play-clip__options__option .hubicon-video_camera_front1 {
    font-size: 20px;
    color: #FD9843;
}

.baloa-play-clip__options__option .icon-chevron-roght {
    font-size: 20px;
    cursor: pointer;
    margin-left: auto;
}

.baloa-play-clip__options__option .hubicon-check_circle_fill {
    font-size: 20px;
    cursor: pointer;
    margin-left: auto;
    opacity: 50%;
}

.baloa-play-clip__options__option.disabled {
    cursor: not-allowed;
    pointer-events: none;
}

.baloa-play-clip__options__option.disabled .baloa-names,
.baloa-play-clip__options__option.disabled .icon-chevron-roght,
.baloa-play-clip__options__option.disabled .hubicon-video_camera_front1,
.baloa-play-clip__options__option.disabled .hubicon-video_library1::before {
    opacity: 0.4;
}

.baloa-play-clip__right-section .baloa-normal-medium {
    font-size: 18px;
    color: var(--primary-very-dark-color);
    line-height: unset;
}

.baloa-play-clip__right-section__match {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    margin-top: 12px;
}

.baloa-play-clip__right-section__match img {
    width: 162px;
    height: 99px;
    border-radius: 4px;
    object-fit: cover;
}

.baloa-play-clip__right-section .baloa-play-clip__right-section__match .baloa-names {
    color: var(--primary-very-dark-color);
    line-height: unset;
    margin-top: 0;
    cursor: pointer;
}

.baloa-play-clip__right-section__match .icon-chevron-roght {
    font-size: 20px;
}

.baloa-play-clip__right-section .baloa-names {
    font-weight: var(--font-regular);
    color: var(--basic-gray-color);
    margin-top: 18px;
}

.baloa-play-clip__right-section .baloa-names.value {
    color: var(--primary-very-dark-color);
    margin-top: 0;
}

.baloa-play-clip__options__subscribe {
    background: var(--new-informative-banner-bg-color);
    border-radius: 4px;
    padding: 12px;
    margin-top: 10px;
    text-align: center;
}

.baloa-play-clip__options__subscribe .hubicon-info::before {
    font-size: 22px;
    color: var(--new-informative-banner-color);
}

.baloa-play-clip__options__subscribe .baloa-table {
    color: var(--primary-very-dark-color);
    margin-top: 4px;
}

.baloa-play-clip__options__subscribe .button {
    font-size: 15px;
    padding: 10px;
    width: 100%;
    margin-top: 8px;
}

.baloa-play-clip__info {
    padding: 12px;
    border-radius: 4px;
    background: var(--new-informative-banner-bg-color);
    margin-top: 10px;
    display: flex;
    align-items: flex-start;
    gap: 4px;
}

.baloa-play-clip__info .hubicon-info::before {
    color: var(--new-informative-banner-color);
    font-size: 22px;
}

.baloa-play-clip__info .baloa-table {
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
}

.baloa-play-clip__info.download {
    display: block;
    text-align: center;
}

.baloa-play-clip__info.download .hubicon-info{
    margin-left: auto;
    margin-right: auto;
}

.baloa-play-clip__info__conditions{
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: start;
}

.baloa-play-clip__info.download .baloa-table.counter {
    font-weight: var(--font-regular);
    margin-top: 6px;
}

.baloa-play-clip__info.download .baloa-table.counter .value{
    font-weight: var(--font-medium);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .baloa-play-clip__container {
        flex-direction: column;
        padding: 10px;
        gap: 10px;
    }

    .baloa-play-clip__left-section {
        width: 100%;
        padding: 12px;
    }

    .baloa-play-clip__section {
        width: 100%;
    }

    .baloa-play-clip__left-section .baloa-normal-medium {
        font-size: 16px;
    }

    .baloa-play-clip__right-section .baloa-normal-medium {
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-clip-component/BaloaPlayClipComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;IAGI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;;;IAII,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,sBAAsB;QACtB,aAAa;QACb,SAAS;IACb;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".baloa-play-clip__container {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 32px 39px;\n}\n\n.baloa-play-clip__left-section {\n    border-radius: 8px;\n    background: var(--white-color);\n    padding: 24px;\n    width: calc(50% - 12px);\n}\n\n.baloa-play-clip__section {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: calc(50% - 12px);\n}\n\n.baloa-play-clip__right-section {\n    border-radius: 8px;\n    background: var(--white-color);\n    padding: 16px;\n}\n\n.baloa-play-clip__actions {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    margin-top: 10px;\n}\n\n.baloa-play-clip__actions-image {\n    border-radius: 8px;\n    width: 175px;\n    height: 182px;\n    position: relative;\n}\n\n.baloa-play-clip__actions img {\n    border-radius: 8px;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.baloa-play-clip__actions-items {\n    padding: 12px 0;\n}\n\n.baloa-play-clip__left-section .baloa-normal-medium {\n    font-size: 18px;\n    color: var(--primary-very-dark-color);\n    line-height: unset;\n}\n\n.baloa-play-clip__actions-items__action {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    margin-bottom: 20px;\n    cursor: pointer;\n}\n\n.baloa-play-clip__actions-items__action .hubicon-play_circle1,\n.baloa-play-clip__actions-items__action .hubicon-download,\n.baloa-play-clip__actions-items__action .hubicon-edit1 {\n    font-size: 20px;\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-play-clip__actions-items__action .baloa-names {\n    color: var(--primary-very-dark-color);\n    line-height: unset;\n}\n\n.baloa-play-clip__actions-items__action.disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n.baloa-play-clip__actions-items__action.disabled .hubicon-play_circle1,\n.baloa-play-clip__actions-items__action.disabled .hubicon-download,\n.baloa-play-clip__actions-items__action.disabled .baloa-names {\n    opacity: 0.4;\n}\n\n.baloa-play-clip__options {\n    margin-top: 10px;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.baloa-play-clip__options__option {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 16px 14px;\n    cursor: pointer;\n}\n\n.baloa-play-clip__options__option:not(:last-child) {\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.baloa-play-clip__options__option .baloa-names {\n    color: var(--primary-very-dark-color);\n    line-height: unset;\n}\n\n.baloa-play-clip__options__option .hubicon-video_library1::before {\n    font-size: 20px;\n    color: #0D6EFD;\n}\n\n.baloa-play-clip__options__option .hubicon-video_camera_front1 {\n    font-size: 20px;\n    color: #FD9843;\n}\n\n.baloa-play-clip__options__option .icon-chevron-roght {\n    font-size: 20px;\n    cursor: pointer;\n    margin-left: auto;\n}\n\n.baloa-play-clip__options__option .hubicon-check_circle_fill {\n    font-size: 20px;\n    cursor: pointer;\n    margin-left: auto;\n    opacity: 50%;\n}\n\n.baloa-play-clip__options__option.disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n.baloa-play-clip__options__option.disabled .baloa-names,\n.baloa-play-clip__options__option.disabled .icon-chevron-roght,\n.baloa-play-clip__options__option.disabled .hubicon-video_camera_front1,\n.baloa-play-clip__options__option.disabled .hubicon-video_library1::before {\n    opacity: 0.4;\n}\n\n.baloa-play-clip__right-section .baloa-normal-medium {\n    font-size: 18px;\n    color: var(--primary-very-dark-color);\n    line-height: unset;\n}\n\n.baloa-play-clip__right-section__match {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 16px;\n    margin-top: 12px;\n}\n\n.baloa-play-clip__right-section__match img {\n    width: 162px;\n    height: 99px;\n    border-radius: 4px;\n    object-fit: cover;\n}\n\n.baloa-play-clip__right-section .baloa-play-clip__right-section__match .baloa-names {\n    color: var(--primary-very-dark-color);\n    line-height: unset;\n    margin-top: 0;\n    cursor: pointer;\n}\n\n.baloa-play-clip__right-section__match .icon-chevron-roght {\n    font-size: 20px;\n}\n\n.baloa-play-clip__right-section .baloa-names {\n    font-weight: var(--font-regular);\n    color: var(--basic-gray-color);\n    margin-top: 18px;\n}\n\n.baloa-play-clip__right-section .baloa-names.value {\n    color: var(--primary-very-dark-color);\n    margin-top: 0;\n}\n\n.baloa-play-clip__options__subscribe {\n    background: var(--new-informative-banner-bg-color);\n    border-radius: 4px;\n    padding: 12px;\n    margin-top: 10px;\n    text-align: center;\n}\n\n.baloa-play-clip__options__subscribe .hubicon-info::before {\n    font-size: 22px;\n    color: var(--new-informative-banner-color);\n}\n\n.baloa-play-clip__options__subscribe .baloa-table {\n    color: var(--primary-very-dark-color);\n    margin-top: 4px;\n}\n\n.baloa-play-clip__options__subscribe .button {\n    font-size: 15px;\n    padding: 10px;\n    width: 100%;\n    margin-top: 8px;\n}\n\n.baloa-play-clip__info {\n    padding: 12px;\n    border-radius: 4px;\n    background: var(--new-informative-banner-bg-color);\n    margin-top: 10px;\n    display: flex;\n    align-items: flex-start;\n    gap: 4px;\n}\n\n.baloa-play-clip__info .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n    font-size: 22px;\n}\n\n.baloa-play-clip__info .baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-play-clip__info.download {\n    display: block;\n    text-align: center;\n}\n\n.baloa-play-clip__info.download .hubicon-info{\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.baloa-play-clip__info__conditions{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    text-align: start;\n}\n\n.baloa-play-clip__info.download .baloa-table.counter {\n    font-weight: var(--font-regular);\n    margin-top: 6px;\n}\n\n.baloa-play-clip__info.download .baloa-table.counter .value{\n    font-weight: var(--font-medium);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .baloa-play-clip__container {\n        flex-direction: column;\n        padding: 10px;\n        gap: 10px;\n    }\n\n    .baloa-play-clip__left-section {\n        width: 100%;\n        padding: 12px;\n    }\n\n    .baloa-play-clip__section {\n        width: 100%;\n    }\n\n    .baloa-play-clip__left-section .baloa-normal-medium {\n        font-size: 16px;\n    }\n\n    .baloa-play-clip__right-section .baloa-normal-medium {\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
